"use client"

import { useRouter } from "@/i18n/navigation"

/**
 * The template sites' red "Back" pill at the foot of their content pages.
 * Goes back in history when there is somewhere to go back to in this tab,
 * home otherwise (a page opened straight from a search result or a link).
 */
export function BackButton({ label }: { label: string }) {
  const router = useRouter()
  return (
    <button
      type="button"
      onClick={() => {
        if (window.history.length > 1) router.back()
        else router.push("/")
      }}
      className="w-fit rounded-[15px] bg-primary px-2.5 font-display text-[13pt] leading-[28px] text-primary-foreground shadow-[inset_0_-2px_0_rgb(0_0_0/0.25)] hover:bg-primary/85"
    >
      {label}
    </button>
  )
}
